"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BillingDetailsLegacyFetcher = void 0;
var date_fns_1 = require("date-fns");
var react_1 = __importDefault(require("react"));
var legacy_queries_1 = require("../../../shared/api/legacy-queries");
var mappings_1 = require("../../../shared/api/mappings");
var Error_1 = require("../components/Error");
var Loading_1 = require("../components/Loading");
var ui_1 = require("../pages/BillingDetails/ui");
var mapBillingLegacyResponseToBillingDetailsCX = function (data) {
    if (!data.billingSummary) {
        return null;
    }
    if ('latestPeriod' in data.billingSummary) {
        return data.billingSummary.latestPeriod.data;
    }
    return data.billingSummary.billablePeriod.data;
};
function BillingDetailsLegacyFetcher(_a) {
    var accountId = _a.accountId, period = _a.period;
    var billingQueryResult = (0, legacy_queries_1.useBillingLegacyQuery)(accountId, period);
    var _b = (0, mappings_1.useMeterReads)(accountId), readsData = _b.data, readsLoading = _b.loading, readsError = _b.error;
    var isLoading = billingQueryResult.isFetching ||
        readsLoading ||
        billingQueryResult.status === 'no-data' ||
        !readsData;
    if (isLoading) {
        return react_1.default.createElement(Loading_1.FetchBillingDetailsLoading, null);
    }
    var hasError = billingQueryResult.status === 'error' || !!readsError;
    if (hasError) {
        return react_1.default.createElement(Error_1.Error, null);
    }
    return (react_1.default.createElement(Data, { period: period, billingResponse: billingQueryResult.data, meterReadingsResponse: readsData }));
}
exports.BillingDetailsLegacyFetcher = BillingDetailsLegacyFetcher;
var Data = function (_a) {
    var billingResponse = _a.billingResponse, meterReadingsResponse = _a.meterReadingsResponse, period = _a.period;
    var data = mapBillingLegacyResponseToBillingDetailsCX(billingResponse);
    var isLatestPeriod = !data ||
        ((billingResponse === null || billingResponse === void 0 ? void 0 : billingResponse.billingSummary) &&
            'latestPeriod' in billingResponse.billingSummary &&
            (0, date_fns_1.isBefore)(data.end, (0, date_fns_1.format)(new Date(), 'yyyy-MM-dd')) &&
            period === 'latest');
    return (react_1.default.createElement(ui_1.BillingDetailsUI, { data: data, isLatestPeriod: isLatestPeriod, meterReadingsResponse: meterReadingsResponse }));
};
